<template>
    <b-container fluid class="div-background pb-2">
        <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
        <div class="Info_Area">
            <div class="CustomizeGroup">
                <b-card-group deck>
                    <b-card
                        border-variant="primary"
                        header="設定設定X軸日期區間"
                        header-bg-variant="primary"
                        header-text-variant="white"
                    >
                        <b-card-text>
                            <b-row style="margin-bottom: 5px; align-items: center;">
                                <b-col cols="12" md="2">
                                    查詢起訖時間：
                                </b-col>
                                <b-col cols="12" md="10" class="d-flex flex-column flex-md-row align-items-center">
                                    <b-input-group style="width: 30vh;display: inline-flex;">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="calendar3"></b-icon>
                                    </b-input-group-prepend>
                                    <datepicker
                                        v-model="timepicker.minvalue"
                                        style="width: 20vh;"
                                        min="1960-01-01"
                                        :max="twtimeparse(timepicker.maxvalue)"
                                    ></datepicker>
                                    </b-input-group>
                                    <span style="display: inline-flex; margin-right: 1rem"
                                    >~</span
                                    >
                                    <b-input-group style="width: 30vh;display: inline-flex;">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="calendar3"></b-icon>
                                    </b-input-group-prepend>
                                    <datepicker
                                        v-model="timepicker.maxvalue"
                                        style="width: 20vh;"
                                        :min="twtimeparse(timepicker.minvalue)"
                                        :max="timepicker.max"
                                    ></datepicker>
                                    </b-input-group>
                                </b-col>
                            </b-row>

                        </b-card-text>
                    </b-card>
                </b-card-group>
                <b-card-group deck>
                    <b-card
                        border-variant="primary"
                        header="設定Y軸標籤(最多選兩項)"
                        header-bg-variant="success"
                        header-text-variant="white"
                    >
                        <b-card-text>
                            <b-row align-v="stretch">
                                <b-col cols="12" md="8" class="mb-4 mb-md-0">
                                    <div class="fillter-group">
                                        <h5>待選項目</h5>
                                        <div class="fillter-content scrollStyle">
                                            <div class="fillter-main-content">
                                                    <b-form-group class="mb-0" >
                                                        <template v-for="(item, index) in yItem.options">
                                                            <b-form-checkbox
                                                            v-model="yItem.selected"
                                                            :key="index"
                                                            :value="item.value"
                                                            :disabled="yItem.selected.length >= 2"
                                                            >{{ item.text }}</b-form-checkbox>
                                                        </template>
                                                    </b-form-group>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <div class="fillter-group">
                                        <h5>已選項目</h5>
                                        <div class="fillter-content scrollStyle">
                                            <div class="fillter-main-content" >
                                                <template  v-for="(item, index) in yItem.selected">
                                                    <b-button variant="success" :key="index">{{ item }}<b-icon icon="x-circle" class="ml-1" aria-hidden="true" @click="removeYItem(item)"></b-icon></b-button>
                                                </template>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end pt-3">
                                        <b-button @click="yItem.selected=[]">全部移除</b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card-text>
                    </b-card>
                </b-card-group>

                <b-card-group deck>
                    <b-card
                        border-variant="warning"
                        header="設定市場作物、交易市場項目(最多可選兩個市場作物+交易市場)"
                        header-bg-variant="warning"
                        header-text-variant="white"
                    >
                        <b-card-text>
                            <b-row align-v="stretch">
                                <b-col cols="12" md="4" class="mb-4 mb-md-0">
                                    <div class="fillter-group">
                                        <h5>市場作物待選項目</h5>
                                        <b-form-input
                                            id="input-1"
                                            type="text"
                                            placeholder="關鍵字查詢"
                                            class="mb-2"
                                            v-model="fruit.CropSearch"
                                        ></b-form-input>
                                        <div v-if="cropSelectIfLoading" class="fillter-content scrollStyle" style="height: 50px;">
                                            <h5>Loading...</h5>
                                            <b-overlay
                                            :show="cropSelectIfLoading"
                                            rounded="sm"
                                            >
                                            </b-overlay>
                                        </div>
                                        <div v-else class="fillter-content scrollStyle">
                                            <div  class="fillter-main-content">
                                                <b-form-group class="mb-0">
                                                    <template v-for="(item, index) in fruit.items">
                                                        <b-form-radio
                                                        v-model="fruit.CropSelected"
                                                        :key="index"
                                                        :value="item.code"
                                                        :disabled="fruit.CropMarketSelected.length >= 2"
                                                        >{{ item.label }}</b-form-radio>
                                                    </template>
                                                </b-form-group>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col cols="12" md="4" class="mb-4 mb-md-0">
                                    <div class="fillter-group">
                                        <h5>交易市場待選項目</h5>
                                        <b-form-input
                                            id="input-1"
                                            type="text"
                                            placeholder="關鍵字查詢"
                                            class="mb-2"
                                            v-model="fruit.MarketSearch"
                                        ></b-form-input>
                                        <div v-if="marketSelectIfLoading" class="fillter-content scrollStyle" style="height: 50px;">
                                            <h5>Loading...</h5>
                                            <b-overlay
                                            :show="marketSelectIfLoading"
                                            rounded="sm"
                                            >
                                            </b-overlay>
                                        </div>
                                        <div v-else class="fillter-content scrollStyle">
                                            <div class="fillter-main-content">
                                                <b-form-group class="mb-0">
                                                    <template v-for="(item, index) in fruit.markets">
                                                        <b-form-radio
                                                        v-model="fruit.marketsSelected"
                                                        :key="index"
                                                        :value="item.value"
                                                        :disabled="fruit.CropMarketSelected.length >= 2"
                                                        >{{ item.text }}</b-form-radio>
                                                    </template>
                                                </b-form-group>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <div class="fillter-group">
                                        <h5>已選項目</h5>
                                        <div class="fillter-content scrollStyle">
                                        <div class="fillter-main-content">
                                            <template v-for="(item, index) in fruit.CropMarketSelected">
                                                <b-button variant="warning" :key="index">{{ item.crop + '-' + item.market}}<b-icon icon="x-circle" class="ml-1" aria-hidden="true" @click="removeCropMarket(item)"></b-icon></b-button>
                                            </template>
                                        </div>

                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end pt-3">
                                    <!-- <b-button variant="success">加入</b-button> -->
                                    <b-button class="ml-2" @click="removeCropMarketAll">全部移除</b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card-text>
                    </b-card>
                </b-card-group>
            </div>
            <div class="d-flex justify-content-center">
                <b-button variant="primary" size="lg" @click="ChartAnalysis">送出查詢</b-button>
                <b-button variant="outline-danger" size="lg" class="ml-2" @click="removeAll">清除設定</b-button>
            </div>
        </div>

        <div class="Info_Area">
            <b-overlay
                :show="chartIfLoading"
                rounded="sm"
            >
            <apexchart
                ref="chart1ref"
                height="450"
                type="line"
                :options="fruit.obj.chart.options"
                :series="fruit.obj.chart.series"
                :responsive="true"
            ></apexchart>
            </b-overlay>
            <div >
                <span style="color: darkblue;">「交易量」及「拍賣均價」會依照所點選交易市場顯示該市場資料；「全國交易量」及「全國拍賣均價」則不會顯示各市場交易量與價格。</span>
            </div>
        </div>

    </b-container>
</template>

<script>
import datepicker from "@/components/Datepicker.vue";

export default {
components: {
    datepicker,
},
computed: {

},
watch:{
    "fruit.CropSelected"(val){
        if(val != "") {
            this.fruit.marketsSelected = "";
            this.fruit.markets = [];
            this.fruit.MarketSearch = "";
            let localmintime = this.timepicker.minvalue.split("-");
            localmintime[0] = parseInt(localmintime[0]) + 1911;
            let localmaxtime = this.timepicker.maxvalue.split("-");
            localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;
            let obj = {
                start_date: localmintime.join("-"),
                end_date: localmaxtime.join("-"),
                CROP_CODE: val,
            };
            this.marketSelectIfLoading = true;
            this.FunctionToken(this.getMarketFromCrop, obj);
        }

    },
    "cropSelectIfLoading"(val){
        if(!val && this.marketSelectIfLoading){
            let localmintime = this.timepicker.minvalue.split("-");
            localmintime[0] = parseInt(localmintime[0]) + 1911;
            let localmaxtime = this.timepicker.maxvalue.split("-");
            localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;
            let obj = {
                start_date: localmintime.join("-"),
                end_date: localmaxtime.join("-"),
                CROP_CODE: this.fruit.CropSelected,
            };
            this.marketSelectIfLoading = true;
            this.FunctionToken(this.getMarketFromCrop, obj);
        }
    },
    "fruit.marketsSelected"(val){

        if(val != ""){
            let cropIndex = this.fruit.items.findIndex((x) => x.code == this.fruit.CropSelected);
            let marketIndex = this.fruit.markets.findIndex((x) => x.value == val);
            let index = this.fruit.CropMarketSelected.findIndex((x) => x.marketCode == val && x.cropCode == this.fruit.CropSelected);
            if(index == -1){
                //this.fruit.CropMarketSelectedName.push(this.fruit.items[cropIndex].label+"-"+this.fruit.markets[marketIndex].text);
                let obj={
                    crop : this.fruit.items[cropIndex].label,
                    market : this.fruit.markets[marketIndex].text,
                    cropCode : this.fruit.CropSelected,
                    marketCode : val
                }
                this.fruit.CropMarketSelected.push(obj);
            }
        }
    },
    "fruit.CropSearch"(val){
        if(val != ""){
            this.fruit.marketsSelected="";
            this.fruit.items = this.fruit.itemsTemp.filter((x) => x.label.includes(val));
        }
        else{
            this.fruit.items = this.fruit.itemsTemp;
        }
    },
    "fruit.MarketSearch"(val){
        if(val != ""){
            this.fruit.markets = this.fruit.marketsTemp.filter((x) => x.text.includes(val));
        }
        else{
            this.fruit.markets = this.fruit.marketsTemp;
        }
    },
    "timepicker.minvalue"(){
        this.CropFromDate();
    },
    "timepicker.maxvalue"(){
        this.CropFromDate();
    }
},
data() {
    var date = new Date();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    //var thisyear = now.getFullYear();
    const maxDate = new Date(today);
    // maxDate.setDate(date.getDate() + 1);
    const minDate = new Date(today);
    minDate.setDate(date.getDate() - 30); //取前30天的日期
    //minDate.setDate(date.getDate() - 365);//取一年前的日期

    var taiwanMinDate = minDate
    .toLocaleString()
    .split(" ")[0]
    .split("/");
    taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
    taiwanMinDate[1] =
    taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
    taiwanMinDate[2] =
    taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
    var taiwanMaxDate = maxDate
    .toLocaleString()
    .split(" ")[0]
    .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
    taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
    taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
        timepicker: {
            minvalue: taiwanMinDate.join("-"),
            maxvalue: taiwanMaxDate.join("-"),
            // minvalue: "110-07-12",
            // maxvalue: "110-07-15",
            max: maxDate
            .toLocaleString()
            .split(" ")[0]
            .split("/")
            .join("-"),
            min: minDate
            .toLocaleString()
            .split(" ")[0]
            .split("/")
            .join("-"),
        },
        yItem:{
            selected:[],
            optionlist1:[
                {text:"嘉義縣產地均價",value:"嘉義縣產地均價"},
                {text:"農糧署產地價格監控",value:"農糧署產地價格監控"},
            ],
            optionlist2:[
                {text:"交易量",value:"交易量"},
                {text:"拍賣均價",value:"拍賣均價"},
                {text:"全國交易量",value:"全國交易量"},
                {text:"全國拍賣均價",value:"全國拍賣均價"},
            ],
            options:[],
        },
        fruit:{
            itemsTemp:[],
            marketsTemp:[],
            items:[],
            markets:[],
            marketsSelected:"",
            CropSelected:"",
            CropMarketSelected:[],
            CropSearch:"",
            MarketSearch:"",
            fruitlist:[],
            obj: {
                chart: {
                    series: [],
                    options: {
                        chart: {
                            height: 450,
                            responsive :true,
                            type: "line",
                            zoom: {
                                enabled: false,
                            },
                        },
                        title: {
                            text: "",
                        },
                        dataLabels: {
                            enabled: true,
                        },
                        stroke: {},
                        // stroke: {
                        //   show: true,
                        //   width: [],
                        //   curve: "straight",
                        //   dashArray: [],
                        // },
                        noData: {
                            text: "No data",
                            align: "center",
                            verticalAlign: "middle",
                        },
                        labels: [],
                        yaxis: [],
                        colors: [
                            "#33a5fb",
                            "#775dd0",
                            "#1c22ce",
                            "#ff7b3d",
                            "#f9b5c0",
                            "#4c1a11",
                            "#6f5c5d",
                            "#88715c",
                            "#86a3be",
                            // "#008FFB",
                            // "#19535f",
                            // "#FEB019",
                            // "#FF4560",
                            // "#775DD0",
                            // "#1c22ce",
                            // "#ff7b3d",
                            // "#f9b5c0",
                            // "#4c1a11",
                        ],
                        xaxis:{
                            group:{}
                        },
                        // xaxis: {
                        //   type: "datetime",
                        //   labels: {
                        //     formatter: function(value, timestamp) {
                        //       var date = new Date(timestamp);
                        //       if (date.getFullYear() < 1975) return;
                        //       var year = date.getFullYear() - 1911;
                        //       return (
                        //         year + "/" + (date.getMonth() + 1) + "/" + date.getDate()
                        //       ); // The formatter function overrides format property
                        //     },
                        //   },
                        // },
                        plotOptions: {
                            bar: {
                            columnWidth: "20%",
                            },
                        },
                        grid: {
                            padding: {
                            right: 10,
                            left: 10,
                            },
                        },
                    },
                    maxYValue: 0,
                    maxVolume: 0,
                },

            },
        },
        cropSelectIfLoading: true,
        marketSelectIfLoading: true,
        chartIfLoading: false,
        breadcrumbItems: [
            {
                text: "首頁",
                href: "#/",
            },
            {
                text: "產銷儀錶板",
                active: true,
            },
            {
                text: "自定義圖表分析",
                active: true,
            },
        ],
        apiGetCropFromDate: (data) =>
            this.userRequest.post("/API/Default/getCropFromDate", data),
        apiGetMarketFromCrop: (data) =>
            this.userRequest.post("/API/Default/getMarketFromCrop", data),
        apiMixinAPI: (data) =>
            this.userRequest.post("/API/Default/MixinAPI", data),
    };
},
created(){
    this.checkLogin();

},
mounted() {


},
methods:{
    checkLogin() {
        let TokenID = sessionStorage.getItem("TokenID");
        if (TokenID) {
            this.checkPermission();
            console.log("this.$route.params.type",this.$route.params.type);
            // if(this.$route.params.type == 1){
            //     this.yItem.options = this.yItem.optionlist1.concat(this.yItem.optionlist2);
            // }
            // else{
            //     this.yItem.options = this.yItem.optionlist2;
            // }
            // this.init();
        } else {
            alert("無權限檢視此頁面，請登入帳號");
            this.$router.push({ path: "/login" });
        }
    },
    checkPermission(){
        
        let data = { PJ_ID: ["PJ000000000034","PJ000000000035"], fun: this.checkByPJID };
        this.FunctionToken(this.Authority3, data);
    },
    checkByPJID(value) {
        if (!value) {
            alert("無權限檢視此頁面，將返回首頁");
            this.$router.push({ path: "/" });
        } else {
            if(this.$route.params.type == 1){
                this.yItem.options = this.yItem.optionlist1.concat(this.yItem.optionlist2);
            }
            else{
                this.yItem.options = this.yItem.optionlist2;
            }
            this.init();
        }
    },
    twtimeparse(item) {
        let tt = item.split("-");
        tt[0] = parseInt(tt[0]) + 1911;
        return tt.join("-");
    },
    init(){
        this.CropFromDate();
    },
    removeYItem(item){
        this.yItem.selected = this.yItem.selected.filter((i) => i !== item);
    },
    removeCropMarket(item){
        this.fruit.CropMarketSelected = this.fruit.CropMarketSelected.filter((i) => i !== item);
        this.fruit.marketsSelected = "";
    },
    removeCropMarketAll(){
        this.fruit.CropMarketSelected = [];
        this.fruit.marketsSelected = "";
        this.fruit.CropSearch = "";
        this.fruit.MarketSearch = "";
        //this.init();
    },
    removeAll(){
        var date = new Date();
        let now = new Date();
        let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        //var thisyear = now.getFullYear();
        let maxDate = new Date(today);
        // maxDate.setDate(date.getDate() + 1);
        let minDate = new Date(today);
        minDate.setDate(date.getDate() - 30);
        let taiwanMinDate = minDate
        .toLocaleString()
        .split(" ")[0]
        .split("/");
        taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
        taiwanMinDate[1] =
        taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
        taiwanMinDate[2] =
        taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
        let taiwanMaxDate = maxDate
        .toLocaleString()
        .split(" ")[0]
        .split("/");
        taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
        taiwanMaxDate[1] =
        taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
        taiwanMaxDate[2] =
        taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
        this.timepicker.minvalue = taiwanMinDate.join("-");
        this.timepicker.maxvalue = taiwanMaxDate.join("-");
        this.yItem.selected=[];
        this.fruit.CropMarketSelected = [];
        this.fruit.marketsSelected = "";
        this.fruit.CropSearch = "";
        this.fruit.MarketSearch = "";
        this.fruit.CropSelected="";
        this.fruit.obj.chart.series = [];
        this.fruit.obj.chart.options.yaxis = [];
        this.fruit.obj.chart.options.labels = [];
        this.fruit.obj.chart.maxYValue = 0;
        this.CropFromDate();
    },
    CropFromDate(){
        let localmintime = this.timepicker.minvalue.split("-");
        localmintime[0] = parseInt(localmintime[0]) + 1911;
        let localmaxtime = this.timepicker.maxvalue.split("-");
        localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;
        let obj = {
            start_date: localmintime.join("-"),
            end_date: localmaxtime.join("-"),
        };
        this.fruit.items = [];
        this.fruit.itemsTemp = [];
        this.removeCropMarketAll();
        //this.this.yItem.selected = [];
        this.cropSelectIfLoading = true;
        this.marketSelectIfLoading = true;


        this.FunctionToken(this.getCropFromDate, obj);
    },
    getCropFromDate(data){
        this.apiGetCropFromDate(data)
            .then((res) =>{
                const json = JSON.parse(res.data);
                if (json.Status) {
                    let arr = JSON.parse(json.Data);
                    arr.forEach((x) => {
                        let obj = {
                            label: x.CROP,
                            code: x.CROP_CODE,
                            disabled: true,
                        };
                        this.fruit.items.push(obj);
                        this.fruit.itemsTemp.push(obj);
                    });
                    this.fruit.CropSelected = this.fruit.items[0].code;
                    this.cropSelectIfLoading = false;
                }
            })
    },
    getMarketFromCrop(data){
        this.apiGetMarketFromCrop(data)
            .then((res) => {
                const json = JSON.parse(res.data);
                this.fruit.marketsTemp = [];
                if (json.Status) {
                    let arr = JSON.parse(json.Data);
                    arr.forEach((x) => {
                        let obj = {
                            text: x.MARKET,
                            value: x.MARKET_CODE,
                        };
                        this.fruit.markets.push(obj);
                        this.fruit.marketsTemp.push(obj);
                    });
                    this.marketSelectIfLoading = false;
                }
            })
    },
    ChartAnalysis(){
        if(this.yItem.selected.length == 0){
            alert("請至少選擇一個Y軸標籤");
        }
        else if(this.fruit.CropMarketSelected.length == 0){
            alert("請至少選擇一個市場作物+交易市場");
        }
        else{
            let localmintime = this.timepicker.minvalue.split("-");
            localmintime[0] = parseInt(localmintime[0]) + 1911;
            let localmaxtime = this.timepicker.maxvalue.split("-");
            localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;
            let obj = {
                start_date: localmintime.join("-"),
                end_date: localmaxtime.join("-"),
                cropMarkets: this.fruit.CropMarketSelected,
            };
            this.fruit.obj.chart.series = [];
            this.fruit.obj.chart.options.yaxis = [];
            this.fruit.obj.chart.options.labels = [];
            this.fruit.obj.chart.maxYValue = 0;
            this.fruit.obj.chart.maxVolume = 0;
            this.chartIfLoading = true;
            this.FunctionToken(this.getChartAnalysis, {TYPE:"CUSTOMIZEANALYSIS",CustomizeData:obj});
        }
    },
    getChartAnalysis(data){
        this.apiMixinAPI(data)
            .then((res) => {
                this.fruit.fruitlist = [];
                const json = JSON.parse(res.data);
                if (json.Status) {
                    let arr = JSON.parse(json.Data);
                    console.log("getChartAnalysis",arr);
                    arr.forEach((item) =>{
                        let obj = {
                            items : item.CROP_PRICEMNG_TRADE_OUT,
                            BA_items : item.BA_TRADE_M_OUTPUT,
                            All_items: item.ALL_CROP_PRICEMNG_TRADE_OUT,
                        }
                        this.fruit.fruitlist.push(obj);

                    })
                    console.log("fruitlist",this.fruit.fruitlist);
                    this.createNewChart();
                }
            })
    },
    createNewChart(){
        // this.fruit.obj.chart.series = [];
        // this.fruit.obj.chart.options.yaxis = [];
        // this.fruit.obj.chart.options.labels = [];

        let datelist = [],serieslist = [];
            // mainlist =[],
            // serieslist = [],
            // maxValue = 0;
        this.fruit.fruitlist.forEach((x) => {
            let items = x.items;
            items.forEach((item) =>{
                if(datelist.indexOf(item.ANA_DATE) == -1){
                    datelist.push(item.ANA_DATE);
                }
            })
            //選項有全國時才加入全國的日期
            //console.log("this.yItem.selected.includes",this.yItem.selected ,this.yItem.selected.includes("全國"))
            let yindex = this.yItem.selected.findIndex((x) => x == "全國拍賣均價" || x == "全國交易量");
            if(yindex != -1){
                let BA_items = x.BA_items
                BA_items.forEach((item) =>{
                    if(datelist.indexOf(item.ANA_DATE) == -1){
                        datelist.push(item.ANA_DATE);
                    }
                })
            }



        })
        datelist.sort();
        // //y軸 資料
        for(let i = 0; i < this.yItem.selected.length; i++){
            let outobj = this.switchYItem(this.yItem.selected[i],datelist,i);

            outobj.serieslist.forEach((series) =>{
                serieslist.push(series);
            })
            outobj.option.forEach((option) =>{
                    this.fruit.obj.chart.options.yaxis.push(option);
            })
        }

        let yindex = this.yItem.selected.findIndex((x) => x == "交易量" || x == "全國交易量");
        let yindex2 = this.yItem.selected.findIndex((x) => x == "嘉義縣產地均價" || x == "全國拍賣均價" || x == "拍賣均價" || x == "農糧署產地價格監控");
        if(yindex == -1 && yindex2 != -1){
            this.fruit.obj.chart.options.yaxis.forEach((option) =>{
                option.max = this.fruit.obj.chart.maxYValue;
            })
        }
        else if(yindex != -1 && yindex2 == -1){
            this.fruit.obj.chart.options.yaxis.forEach((option) =>{
                option.max = this.fruit.obj.chart.maxVolume;
            })
        }

        this.fruit.obj.chart.series = serieslist;

        let datelist2 = this.getnewdate2(datelist);
        //console.log("datelist2",datelist2);
        this.fruit.obj.chart.options.labels = datelist2;
        this.parseSpecificStingToDashed();
        if (this.$refs.chart1ref != undefined) {
            this.$refs.chart1ref.updateSeries(this.fruit.obj.chart.series);
            this.$refs.chart1ref.updateOptions(this.fruit.obj.chart.options);
            this.chartIfLoading = false;
            // this.$nextTick(() => {
            //     let markers = document.getElementsByClassName(
            //         "apexcharts-legend-marker"
            //     );
            //     // markers.forEach((x) => {
            //     //   console.log(x.nextSibling.innerText);
            //     // });
            //     for (let i = 0; i < markers.length; i++) {
            //         let marker = markers[i];
            //         if (marker.nextSibling && marker.nextSibling.innerText === "全國拍賣均價") {
            //         const imgURL = 'imgs/line-dash01.svg';
            //         const xhr = new XMLHttpRequest();
            //         xhr.open('GET', imgURL, true);
            //         xhr.responseType = 'blob';
            //         xhr.onload = function() {
            //             if (this.status === 200) {
            //             const blob = this.response;
            //             const reader = new FileReader();
            //             reader.readAsDataURL(blob);
            //             reader.onloadend = function() {
            //                 const base64data = reader.result.replace(/^data:.+;base64,/, '');
            //                 marker.outerHTML =
            //                 '<span class="apexcharts-legend-marker" rel="' +
            //                 i +
            //                 1 +
            //                 '" data:collapsed="false" style="width: 30px; border-width: 0px;"><img src="data:image/svg+xml;base64,' + base64data + '" crossorigin="anonymous" /></span>';
            //             };
            //             }
            //         };
            //         xhr.send();
            //         // marker.outerHTML =
            //         //   '<span class="apexcharts-legend-marker" rel="' +
            //         //   i +
            //         //   1 +
            //         //   '" data:collapsed="false" style="width: 30px; border-width: 0px;"><img src="imgs/line-dash01.svg" crossorigin="anonymous" /></span>';

            //         } else if (marker.nextSibling && marker.nextSibling.innerText === "嘉義縣產地均價") {
            //         const imgURL = 'imgs/line-dash02.svg';
            //         const xhr = new XMLHttpRequest();
            //         xhr.open('GET', imgURL, true);
            //         xhr.responseType = 'blob';
            //         xhr.onload = function() {
            //             if (this.status === 200) {
            //             const blob = this.response;
            //             const reader = new FileReader();
            //             reader.readAsDataURL(blob);
            //             reader.onloadend = function() {
            //                 const base64data = reader.result.replace(/^data:.+;base64,/, '');
            //                 marker.outerHTML =
            //             '<span class="apexcharts-legend-marker" rel="' +
            //             i +
            //             1 +
            //             '" data:collapsed="false" style="width: 30px; border-width: 0px;"><img src="data:image/svg+xml;base64,' + base64data + '" crossorigin="anonymous" /></span>';
            //             };
            //             }
            //         };xhr.send();
            //         // marker.outerHTML =
            //         //   '<span class="apexcharts-legend-marker" rel="' +
            //         //   i +
            //         //   1 +
            //         //   '" data:collapsed="false" style="width: 30px; border-width: 0px;"><img src="imgs/line-dash02.svg" crossorigin="anonymous" /></span>';
            //         }
            //     }
            //     });
        }
    },
    switchYItem(Type,datelist,i){
        let obj ={};
        switch(Type){
            case "嘉義縣產地均價":
                obj = this.GetChiayiAveragePrice(datelist,i);
                break;
            case "農糧署產地價格監控":
                obj = this.GetMantainPrice(datelist,i);
                break;
            case "拍賣均價":
                obj = this.GetThisAvgPrice(datelist,i);
                break;
            case "交易量":
                obj = this.GetThisVolume(datelist,i);
                break;
            case "全國交易量":
                obj = this.GetAllVolume(datelist,i);
                break;
            case "全國拍賣均價":
                obj = this.GetAllAvgPrice(datelist,i);
                break;
        }
        return obj;
    },
    GetThisAvgPrice(datelist,i){
        let serieslist = [],
            avgoption = [],
            maxprice = 0 ;
        this.fruit.fruitlist.forEach((fruitData) => {
            let avgPriceList = [] ,
            market = "",
            crop ="";

            datelist.forEach((date) =>{
                let allavgprice = 0,avgvalue1 =0 ,count = 0;
                let item = fruitData.items.filter((x) => x.ANA_DATE == date);
                if(item.length  == 0) {
                    avgPriceList.push(0);
                }else{
                    item.forEach((x) =>{
                        if(market == "") market = x.MARKET;
                        if(crop == "") crop = x.CROP;
                        allavgprice += x.PRICE_AVG;
                        count++;
                    })
                    if(count != 0 ) avgvalue1 = allavgprice / count;
                    avgvalue1 = avgvalue1.toFixed(1);
                    if(avgvalue1 > maxprice) maxprice = Math.ceil(avgvalue1);
                    avgPriceList.push(avgvalue1);
                }
            })
            let obj = {
                name : crop+"-"+market+"拍賣均價",
                type : i == 0 ? "column" : "line",
                data : avgPriceList,
            }
            serieslist.push(obj);


        })
        let remainder = maxprice % 5;
        if(remainder != 0) maxprice += (5-remainder);
        if(maxprice > this.fruit.obj.chart.maxYValue) this.fruit.obj.chart.maxYValue = maxprice;
        for(let j = 0 ; j < serieslist.length ; j++){
            if(avgoption.length == 0){
                avgoption.push({
                    seriesName: "拍賣均價",
                    showAlways: false,
                    opposite: i != 0 ? true : false,
                    max: maxprice,
                    min: 0,
                    tickAmount:5,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    title: {
                    text: "價格 ( 元 / 公斤 )",
                    },
                })
            }
            else{
                    avgoption.push({
                    seriesName: "拍賣均價",
                    show: false,
                    max: maxprice,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    min: 0,
                });
            }
        }

        let out ={
            serieslist : serieslist,
            option : avgoption
        }

        return out;
    },
    GetThisVolume(datelist,i){
        let serieslist = [],
            volumeoption = [],
            maxvolume = 0;
        this.fruit.fruitlist.forEach((fruitData) =>{
            let volumelist = [],
                market = "",
                crop ="";

            datelist.forEach((date) =>{
                let allvolume = 0,
                count = 0 ,
                volumevalue1 =0;

                let item = fruitData.items.filter((x) => x.ANA_DATE == date);
                if(item.length == 0){
                    volumelist.push(0);
                }else{
                    item.forEach((x) =>{
                        if(market == "") market = x.MARKET;
                        if(crop == "") crop = x.CROP;
                        allvolume += x.VOLUME;
                        count++;
                    })
                    if(count != 0) volumevalue1 = Math.round(allvolume / count);
                    if(volumevalue1 > maxvolume) maxvolume = volumevalue1;
                    volumelist.push(volumevalue1.toFixed(0));
                }
            })
            let obj = {
                name : crop+"-"+market+"交易量",
                type : i == 0 ? "column" : "line",
                data : volumelist,
            }
            serieslist.push(obj);

        })

        let remainder = Math.ceil(maxvolume / 500) ;
        //console.log("remainder",maxvolume,remainder);
        if(remainder != 0) maxvolume = remainder * 500 ;
        if(maxvolume > this.fruit.obj.chart.maxVolume) this.fruit.obj.chart.maxVolume = maxvolume;
        for(let j=0 ; j < serieslist.length ; j++){
            if(volumeoption.length == 0){
                volumeoption.push({
                    seriesName: "交易量",
                    opposite: i != 0 ? true : false,
                    max: maxvolume,
                    min: 0,
                    tickAmount:5,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    title: {
                        text: "交易量(公斤)",
                    },
                })
            }
            else{
                volumeoption.push({
                    seriesName: "交易量",
                    max: maxvolume,
                    min: 0,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    show: false,
                });
            }
        }
        let out ={
            serieslist : serieslist,
            option : volumeoption
        }
        return out;
    },
    GetAllAvgPrice(datelist,i){
        let serieslist = [],
            avgoption = [],
            maxprice = 0 ;
        this.fruit.fruitlist.forEach((fruitData) => {
            let avgPriceList = [] ,
            market = "全國",
            crop =fruitData.items[0].CROP;

            datelist.forEach((date) =>{
                let avgvalue1 =0;
                for (let j in fruitData.BA_items) {
                    if (
                        fruitData.BA_items[j].ANA_DATE == date
                    ) {
                        avgvalue1 = Math.round(fruitData.BA_items[j].WA);
                        if(avgvalue1 > maxprice) maxprice = Math.ceil(avgvalue1);
                        avgPriceList.push(avgvalue1);
                    }
                }
            })
            let obj = {
                name : crop+"-"+market+"拍賣均價",
                type : i == 0 ? "column" : "line",
                data : avgPriceList,
            }
            serieslist.push(obj);
        })
        let remainder = maxprice % 5;
        if(remainder != 0) maxprice += (5-remainder);
        if(maxprice > this.fruit.obj.chart.maxYValue) this.fruit.obj.chart.maxYValue = maxprice;
        for(let y = 0 ; y < serieslist.length ; y++){
            if(avgoption.length == 0){
                avgoption.push({
                    seriesName: "拍賣均價",
                    showAlways: false,
                    opposite: i != 0 ? true : false,
                    max: maxprice,
                    min: 0,
                    tickAmount:5,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    title: {
                    text: "價格 ( 元 / 公斤 )",
                    },
                })
            }
            else{
                    avgoption.push({
                    seriesName: "拍賣均價",
                    show: false,
                    max: maxprice,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    min: 0,
                });
            }
        }

        let out ={
            serieslist : serieslist,
            option : avgoption
        }
        console.log("out",out);
        return out;
    },
    GetAllVolume(datelist,i){
        let serieslist = [],
            volumeoption = [],
            maxvolume = 0;
        this.fruit.fruitlist.forEach((fruitData) =>{
            let volumelist = [],
                market = "全國",
                crop ="";
                datelist.forEach((date) =>{
                    let allvolume = 0,count = 0 , volumevalue1 = 0 ;
                    fruitData.All_items.forEach((x) =>{
                        if(crop == "") crop = x.CROP;
                        if(x.ANA_DATE == date){
                            allvolume += x.VOLUME;
                            count++ ;
                        }
                    })
                    if(count != 0) volumevalue1 = Math.round(allvolume / count);
                    else volumevalue1 = 0;
                    if(volumevalue1 > maxvolume) maxvolume = volumevalue1;

                    volumelist.push(volumevalue1);
                })
                let obj = {
                    name : crop+"-"+market+"交易量",
                    type : i == 0 ? "column" : "line",
                    data : volumelist,
                }
                serieslist.push(obj);
        })
        let remainder = Math.ceil(maxvolume / 500) ;
        //console.log("remainder",maxvolume,remainder);
        if(remainder != 0) maxvolume = remainder * 500 ;
        if(maxvolume > this.fruit.obj.chart.maxVolume) this.fruit.obj.chart.maxVolume = maxvolume;
        for(let j=0 ; j < serieslist.length ; j++){
            if(volumeoption.length == 0){
                volumeoption.push({
                    seriesName: "交易量",
                    opposite: i != 0 ? true : false,
                    max: maxvolume,
                    min: 0,
                    tickAmount:5,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    title: {
                        text: "交易量(公斤)",
                    },
                })
            }
            else{
                volumeoption.push({
                    seriesName: "交易量",
                    max: maxvolume,
                    min: 0,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    show: false,
                });
            }
        }
        let out ={
            serieslist : serieslist,
            option : volumeoption
        }
        //console.log("GetAllVolume",out);
        return out;
    },
    GetChiayiAveragePrice(datelist,i){
        let serieslist = [],
            avgoption = [],
            maxprice = 0 ;
        this.fruit.fruitlist.forEach((fruitData) =>{
            let avgPriceList = [] ,
                crop =fruitData.items[0].CROP;
                datelist.forEach((date) =>{
                    let allavgprice = 0,avgvalue1 =0 ,count = 0;
                    fruitData.All_items.forEach((item) =>{
                        if(item.ANA_DATE == date){
                            allavgprice += (item.CM_PRICE_C +
                                            item.CM_PRICE_M +
                                            item.CM_PRICE_F) /3;
                            count++;
                        }
                    })
                    if(count != 0 ) avgvalue1 = allavgprice / count;

                    if(avgvalue1 > maxprice) maxprice = Math.ceil(avgvalue1);
                    if(maxprice > this.fruit.obj.chart.maxYValue) this.fruit.obj.chart.maxYValue = maxprice;
                    if(avgvalue1 == 0) avgPriceList.push(null);
                    else avgPriceList.push(avgvalue1.toFixed(2));
                })
                let obj = {
                    name : crop+"嘉義縣產地均價",
                    type : i == 0 ? "column" : "line",
                    data : avgPriceList,
                }
                serieslist.push(obj);
        })
        let remainder = maxprice % 5;
        if(remainder != 0) maxprice += (5-remainder);
        for(let j = 0 ; j < serieslist.length ; j++){
            if(avgoption.length == 0){
                avgoption.push({
                    seriesName: "嘉義縣產地均價",
                    showAlways: false,
                    opposite: i != 0 ? true : false,
                    max: maxprice,
                    min: 0,
                    tickAmount:5,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    title: {
                    text: "價格 ( 元 / 公斤 )",
                    },
                })
            }
            else{
                    avgoption.push({
                    seriesName: "嘉義縣產地均價",
                    show: false,
                    max: maxprice,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    min: 0,
                });
            }
        }
        let out ={
            serieslist : serieslist,
            option : avgoption
        }
        console.log("GetChiayiAveragePrice",out);
        return out;
    },
    GetMantainPrice(datelist,i){
        let serieslist = [],
            avgoption = [],
            maxprice = 0 ;
        this.fruit.fruitlist.forEach((fruitData) =>{
            let avgPriceList = [] ,
                crop =fruitData.items[0].CROP;
            datelist.forEach((date) =>{
                let allavgprice = 0,avgvalue1 =0 ,count = 0;
                fruitData.All_items.forEach((item) =>{
                    if(item.ANA_DATE == date){
                        allavgprice += item.CM_PRICE_MON;
                        count++;
                    }
                })
                if(count != 0 ) avgvalue1 = allavgprice / count;
                if(avgvalue1 > maxprice) maxprice = Math.ceil(avgvalue1);
                if(maxprice > this.fruit.obj.chart.maxYValue) this.fruit.obj.chart.maxYValue = maxprice;
                if(avgvalue1 == 0) avgPriceList.push(null);
                else avgPriceList.push(avgvalue1.toFixed(2));
            })
            let obj = {
                name : crop+"農糧署產地價格監控",
                type : i == 0 ? "column" : "line",
                data : avgPriceList,
            }
            serieslist.push(obj);
        })

        let remainder = maxprice % 5;
        if(remainder != 0) maxprice += (5-remainder);
        for(let j = 0 ; j < serieslist.length ; j++){
            if(avgoption.length == 0){
                avgoption.push({
                    seriesName: "農糧署產地價格監控",
                    showAlways: false,
                    opposite: i != 0 ? true : false,
                    max: maxprice,
                    min: 0,
                    tickAmount:5,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    title: {
                    text: "價格 ( 元 / 公斤 )",
                    },
                })
            }
            else{
                    avgoption.push({
                    seriesName: "農糧署產地價格監控",
                    show: false,
                    max: maxprice,
                    labels:{
                        formatter: function(val){
                            if(window.isNaN(val)) return 0;
                            return val.toFixed(0);
                        }
                    },
                    min: 0,
                });
            }
        }

        let out = {
            serieslist : serieslist,
            option : avgoption
        }
        console.log("GetMantainPrice",out);
        return out;
    },
    parseSpecificStingToDashed(){
        let num = this.fruit.obj.chart.series.length;
        this.fruit.obj.chart.options.stroke = {
            show: true,
            width: new Array(num).fill(2),
            curve: "smooth",
            dashArray: new Array(num).fill(0),
        };
        this.fruit.obj.chart.options.colors = [
            "#33a5fb",
            "#775dd0",
            "#1c22ce",
            "#ff7b3d",
            "#f9b5c0",
            "#4c1a11",
            "#6f5c5d",
            "#88715c",
            "#86a3be",
        ];
    },
    getnewdate2(date) {
        let datelist = [];
        date.forEach((x) => {
            let date = x.split('T')[0].split("-");
            date[0] = parseInt(date[0]) - 1911;
            datelist.push(date.join("/"));
        });
        return datelist;
    },
}
};
</script>
